import React, { useState, useEffect } from 'react'
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Button from "@material-ui/core/Button";


function AddMedicine() {

    const [selectedMedicine, setSelectedMedicine] = useState("");
    const [dosing, setDosing] = useState("");
    const [medicineList, setMedicineList] = useState([]);
    const [enterDosingError, setEnterDosingError] = useState("false");
    const [presctibedMedicine, setPrescribedMedicine] = useState("false");

    useEffect(() => {
        const link = `/getDrugs`;
        axios
            .get(link)
            .then((res) => {
                setMedicineList(res.data);
                setSelectedMedicine(res.data[0].name);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (dosing !== "") {
            console.log("predpisuje" + selectedMedicine + " " + dosing);
            axios.post("/prescribe", {
                name: selectedMedicine,
                dosing: dosing,
                patientId: localStorage.getItem('currentProfile'),
            }).then(function (response) {
                if (response.data.message === "prescription sent succesfully") {
                    console.log("uspesne poslane");
                    setPrescribedMedicine("true");
                    window.location.reload();
                }
            }).catch(function (error) {
                console.log(error);
            });
        } else {
            setEnterDosingError("true");
        }

    };

    const changeDosing = (e) => {
        e.preventDefault();
        setDosing(e.target.value);
        if (e.target.value !== "") {
            setEnterDosingError("false");
        } else {
            setEnterDosingError("true");
        }
        setPrescribedMedicine("false");
    };

    const changeMedicine = (e) => {
        e.preventDefault();
        setSelectedMedicine(e.target.value);
        setPrescribedMedicine("false");
    };

    return (

        <div>
            <h1>Prescribe medicine</h1>
            <div className="shadow" style={{borderRadius: 8, padding: 28, backgroundColor: "#f2f2f2"}}>
                <form onSubmit={handleSubmit}>
                    <select onChange={changeMedicine}>
                        {medicineList.map((medicine) => <option key={medicine.name} value={medicine.name}>{medicine.name}</option>)}
                    </select>
                    <div>
                        <TextField
                            id="dosing"
                            label="Dosing (hours)"
                            type="text"
                            onChange={changeDosing}
                            fullWidth
                            style={{ width: 350 }}
                        />
                    </div>
                    {enterDosingError === "true" &&
                        <div className="loginSignUpError">Please enter dosing.</div>
                    }
                    {presctibedMedicine === "true" &&
                        <h3 style={{ color: '#6ec286' }}>Prescription created!</h3>
                    }
                    <div className="loginSignUpButton">
                        <Button type="submit" variant="contained" color="secondary">
                            Prescribe
                    </Button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddMedicine
